<template>
  <app-page-title :color="'lips'">
    <template #pageTitleLeft>
      <h1>
        New Client Onboarding
      </h1>
    </template>
    <template #pageTitleRight v-if="!hideFaq">
      <div class="misc-buttons">
        <p class="_mb0 _mrxs">Need Help?</p>
        <router-link
          to="/faq"
          tag="a"
          target='_blank'
          class="btn --sm white grape"
        >
          Frequently asked Questions
        </router-link>
      </div>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'

  export default {
    components: {
      AppPageTitle
    },
    props: {
      hideFaq: Boolean
    }
  }
</script>
